"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderComponent = void 0;
//ANGULAR2 BITS
const router_1 = require("@angular/router");
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const bidder_service_1 = require("./bidder.service");
const _ = require("lodash");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const permission_service_1 = require("./permission.service");
const user_service_1 = require("./user.service");
const login_service_1 = require("./login.service");
const branding_service_1 = require("./branding.service");
let HeaderComponent = class HeaderComponent {
    constructor(_router, _permission, _token, _route, _bidder, _title, _user, _branding, _loginService) {
        this._router = _router;
        this._permission = _permission;
        this._token = _token;
        this._route = _route;
        this._bidder = _bidder;
        this._title = _title;
        this._user = _user;
        this._branding = _branding;
        this._loginService = _loginService;
        this.permission = {};
        this.permissionSubscription = this._permission.getPermissionObservable().subscribe(r => { this.permission = r.permission; });
        this._router.events.subscribe((val) => {
            // see also
            this.currentProduct = this._title.getTitle();
        });
    }
    headerImage(branding, product) {
        return this.canUseBranding(branding) && this.canUseProduct(product);
    }
    isEMXHeaderVisible() {
        return _.isEmpty(this._permission.get());
    }
    defaultHeaderImage(branding) {
        if (!this.permission || !Object.keys(this.permission || {}).length)
            return false;
        return (this.canUseBranding(branding)) &&
            (!this.currentProduct || (this.currentProduct.indexOf('Dashboard') < 0) && (this.currentProduct.indexOf('Control Center') < 0));
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.permissionSubscription.unsubscribe();
        this.permission = {};
    }
    logout() {
        this.permission = {};
        return this._loginService.logout();
    }
    canUseBranding(branding) {
        // if user can see both don't allow seing biddr_connect
        if (branding === 'biddr_connect' && this.canUseBranding('biddr_360'))
            return false;
        return (this.permission && this.permission['system-branding--' + branding]);
    }
    canUseProduct(product) {
        return (this.currentProduct && this.currentProduct.indexOf(product) > -1);
    }
};
exports.HeaderComponent = HeaderComponent;
exports.HeaderComponent = HeaderComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-header',
        templateUrl: 'app/header.component.html',
        styleUrls: ['styles/app.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router,
        permission_service_1.PermissionService,
        token_service_1.TokenService,
        router_1.ActivatedRoute,
        bidder_service_1.BidderService,
        platform_browser_1.Title,
        user_service_1.UserService,
        branding_service_1.BrandingService,
        login_service_1.LoginService])
], HeaderComponent);
//# sourceMappingURL=header.component.js.map